import React from "react";

const ClearCart = ({onClear, onClose}) => (
    <div className="modal-clear">
            <h3>Очистити кошик?</h3>
            <p>Просто хочемо впевнитися, що це не випадково =)</p>
        <button
            onClick={onClear}
            className="primary_button"
            id="modal_clear"
        >Очистити
        </button>
        <button
            onClick={onClose}
            className="primary_button"
            id="modal_close"
        >Скасувати
        </button>
    </div>
);

export default ClearCart;